import { FormattedMessage } from 'react-intl'
const CartHeading = () => (
  <div>
    <h1 className='masthead u-weight--bold'>
      <FormattedMessage id='carts.my_cart' />
    </h1>
  </div>
)

export default CartHeading
